import { useState } from "react";
import useSWR from "swr";
import { fetcher, tsFmt } from "@/lib/api";

const SEV = { info: "text-[#848e9c]", warning: "text-[#fcd535]", error: "text-[#f6465d]", critical: "text-[#f6465d] font-bold" };

export default function Audit() {
  const [type, setType] = useState("");
  const [severity, setSeverity] = useState("");
  const [tab, setTab] = useState("events");
  const [open, setOpen] = useState(null);
  const { data: types } = useSWR("/events/types", fetcher);
  const { data: events } = useSWR(`/events?limit=300${type ? `&type=${type}` : ""}${severity ? `&severity=${severity}` : ""}`, fetcher, { refreshInterval: 15000 });
  const { data: riskEvents } = useSWR(tab === "risk" ? "/risk-events?limit=200" : null, fetcher);
  const rows = tab === "events" ? events : riskEvents;

  return (
    <div className="space-y-3 fade-in">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div><h1 className="font-display text-xl font-bold text-white">Audit Log</h1><p className="text-xs text-[#848e9c] mt-0.5">Immutable chronological trail: auth, settings, AI decisions, risk rejections, orders, fills, kill-switch and protection-mode events. Secrets are redacted before storage.</p></div>
        <div className="flex items-center gap-2">
          <div className="seg">{[["events", "System events"], ["risk", "Risk rejections"]].map(([k, l]) => <button key={k} onClick={() => setTab(k)} className={tab === k ? "on" : ""} data-testid={`audit-tab-${k}`}>{l}</button>)}</div>
          {tab === "events" && (<>
            <select className="input w-auto h-8 py-0" value={type} onChange={(e) => setType(e.target.value)} data-testid="audit-filter-dropdown"><option value="">All types</option>{(types || []).map((t) => <option key={t} value={t}>{t}</option>)}</select>
            <select className="input w-auto h-8 py-0" value={severity} onChange={(e) => setSeverity(e.target.value)} data-testid="audit-severity-dropdown"><option value="">All severities</option>{["info", "warning", "error", "critical"].map((s) => <option key={s}>{s}</option>)}</select>
          </>)}
        </div>
      </div>
      <div className="panel p-1 overflow-x-auto" data-testid="audit-log-table">
        <table className="grid">
          <thead><tr><th>Timestamp</th><th>{tab === "events" ? "Severity" : "Rule"}</th><th>Type</th><th>Message</th><th></th></tr></thead>
          <tbody>
            {(rows || []).length === 0 && <tr><td colSpan={5} className="text-center text-[#5e6673] py-6">No events</td></tr>}
            {(rows || []).map((e) => (
              <tr key={e.id} data-testid="audit-log-row">
                <td className="mono text-[#848e9c]">{tsFmt(e.created_at)}</td>
                <td className={`mono uppercase text-[10px] ${SEV[e.severity] || "text-[#848e9c]"}`}>{e.severity || e.rule}</td>
                <td className="mono text-[#eaecef]">{e.type || "risk_rejection"}</td>
                <td className="text-[#eaecef] whitespace-normal max-w-[600px]">{e.message}</td>
                <td>{e.data && Object.keys(e.data).length > 0 && <button onClick={() => setOpen(open === e.id ? null : e.id)} className="btn-ghost rounded px-2 h-6 text-[10px]" data-testid={`audit-detail-${e.id}`}>{open === e.id ? "hide" : "data"}</button>}
                  {open === e.id && <pre className="mono text-[10px] text-[#848e9c] mt-1 whitespace-pre-wrap max-w-[400px]">{JSON.stringify(e.data, null, 1)}</pre>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
